import { render } from "./HeroiconsOutlineMenuAlt4.vue?vue&type=template&id=23613faa"
const script = {}

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineMenuAlt4.vue"]])

export default __exports__